import { useCallback } from "react";
import { Box, Button, Text } from "@vinomofo/components";
import styled from "styled-components";
import useAuth from "../../hooks/use-auth";
import { FONT_FAMILIES } from "../../styles";
import { scrollToElementBySelector } from "../../utils/smooth-scroll-to";

const Container = styled(Text)`
  font-weight: 500;
  align-self: center;
`;

const LoginButton = styled(Button)`
  font-family: ${FONT_FAMILIES.dmSans};
  background-color: #fbc44e;
  color: #000;
  border: none;
  font-size: 13px;
  border-radius: 35px;
  padding: 11px 20px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
  text-align: center;
  text-decoration: none;
  &:hover {
    background-color: #ffa11c;
    text-decoration: none;
  }
  @media ${({ theme }) => theme.mq.max.mobile} {
    background-color: transparent;
    border: 1px solid #fbc44e;
    color: #fbc44e;
    padding: 10px 10px;
    max-width: 100px;
    font-size: 12px;
    &:hover {
      background-color: #fbc44e;
      text-decoration: none;
      color: #000;
    }
  }
`;

const SignUpButton = styled(Button)`
  font-family: ${FONT_FAMILIES.dmSans};
  background-color: transparent;
  color: #fbc44e;
  border: 1px solid #fbc44e;
  font-size: 13px;
  border-radius: 35px;
  padding: 11px 20px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
  text-align: center;
  text-decoration: none;
  margin-left: 10px;
  &:hover {
    background-color: #fbc44e;
    text-decoration: none;
    color: #000;
  }
  @media ${({ theme }) => theme.mq.max.mobile} {
    background-color: transparent;
    border: 1px solid #fbc44e;
    color: #fbc44e;
    padding: 10px 10px;
    max-width: 100px;
    font-size: 12px;
    &:hover {
      background-color: #fbc44e;
      text-decoration: none;
      color: #000;
    }
  }
`;

const DesktopOnly = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: right;
  @media ${({ theme }) => theme.mq.max.mobile} {
    display: none;
  }
`;

const MobileOnly = styled(Box)`
  display: none;
  width: 100%;
  @media ${({ theme }) => theme.mq.max.mobile} {
    display: flex;
    justify-content: right;
    width: 100%;
  }
`;

const LoginSignup = () => {
  const { login, isAuthenticated } = useAuth();

  const handleLogin = useCallback(() => {
    login({ returnTo: "/whiskymofo" });
  }, [login]);

  const handleSignUp = useCallback(() => {
    scrollToElementBySelector(".hs-button", {
      highlightDuration: 300,
      scale: 1.05,
      glowColor: "rgba(251, 196, 78, 0.5)",
    });
  }, []);

  return (
    <>
      <DesktopOnly>
        <Container
          forwardedAs="div"
          color="white"
          fontFamily={"normal"}
          fontWeight="500"
        >
          {!isAuthenticated ? (
            <Button
              onClick={handleLogin}
              color="white"
              fontFamily={"normal"}
              fontSize={[0, 1]}
              px={20}
              fontWeight="500"
            >
              Login
            </Button>
          ) : (
            <SignUpButton onClick={handleSignUp}>
              Sign Up for Free!
            </SignUpButton>
          )}
        </Container>
      </DesktopOnly>
      <MobileOnly>
        {!isAuthenticated ? (
          <LoginButton onClick={handleLogin}>Login</LoginButton>
        ) : (
          <SignUpButton onClick={handleSignUp}>Sign Up!</SignUpButton>
        )}
      </MobileOnly>
    </>
  );
};

export default LoginSignup;
